import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';

import { TopBar } from '../../components/TopBar';
import { DisclaimerModal } from '../../components/DisclaimerModal';

import './index.scss';

import logos from '../../images/svg/Home/cim_noh_logo_bxlm.svg'; // TODO: change to jpg
import titreFr from '../../images/svg/Home/cim_noh_titre_fr.svg';
import titreNl from '../../images/svg/Home/cim_noh_titre_nl.svg';

type Props = {
    baseUrl?: string;
};
export const Home: FunctionComponent<Props> = ({ baseUrl = '' }) => {
    const { t } = useTranslation();
    const { language = 'fr' } = useParams();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleStartClick = (e: React.MouseEvent) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        navigate(`/${baseUrl}/${language}/welcome`);
    };

    return (
        <>
            <TopBar
                baseUrl={baseUrl}
                withDifficulty={false}
                withHomeLink={false}
            />
            <section className={`${language} container home`}>
                <div className="content">
                    <a
                        id="logos"
                        href={t('home.logos')}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={logos} alt="logos" />
                    </a>
                    <img
                        src={language === 'fr' ? titreFr : titreNl}
                        alt={t('home.fullTitle')}
                        className="title-image"
                    />
                    <a
                        href={`/${baseUrl}/${language}/welcome`}
                        id="start-link"
                        onClick={handleStartClick}
                        aria-label={t('home.start-link')}
                    >
                        {' '}
                    </a>
                    <div className="background" />
                </div>
            </section>
            <DisclaimerModal
                isOpen={isModalOpen}
                onClose={handleModalClose}
                language={language}
            />
        </>
    );
};
